import { render, staticRenderFns } from "./AgeGender.vue?vue&type=template&id=1bb5a02a&scoped=true&"
import script from "./AgeGender.vue?vue&type=script&lang=js&"
export * from "./AgeGender.vue?vue&type=script&lang=js&"
import style0 from "./AgeGender.vue?vue&type=style&index=0&id=1bb5a02a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb5a02a",
  null
  
)

export default component.exports